import * as Sentry from '@sentry/react'
import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import BackgroundNoTrips from './assets/images/BackgroundNoTrips.png'
import { Button } from './components/Button.tsx'

export default function ErrorPage() {
  const error = useRouteError()

  console.error(error)
  Sentry.captureException(error)

  let errorMessage = ''
  const { t } = useTranslation()

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText
  }

  return (
    <div id="error-page">
      <div
        className="min-h-screen flex flex-col justify-center items-center bg-forrest bg-fixed bg-cover pb-32"
        style={{
          backgroundImage: `url(${BackgroundNoTrips})`
        }}
      >
        <h1 className="text-2xl">Oops!</h1>
        <p className="text-2xl">{t('unexpectedErrorSuccess', { ns: 'common' })}</p>
        <p>
          <i>{errorMessage}</i>
        </p>
        <div className="mt-4">
          <Button
            variant="primary"
            label={t('back', { ns: 'common' })}
            onClick={() => {
              window.location.href = '/'
            }}
          />
        </div>
      </div>
    </div>
  )
}
